import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type MerchantState = {
  name: string;
  email: string;
  profilePictureUrl: string;
  setMerchantName: (name: string) => void;
  setMerchantEmail: (email: string) => void;
  setProfilePictureUrl: (url: string) => void;
  updateMerchantInfo: (info: { name?: string; email?: string; profilePictureUrl?: string }) => void;
  resetMerchantInfo: () => void;
};

const initialState = {
  name: '',
  email: '',
  profilePictureUrl: '',
};

export const useMerchantStore = create<MerchantState>()(
  persist(
    (set) => ({
      ...initialState,
      setMerchantName: (name: string) => set({ name }),
      setMerchantEmail: (email: string) => set({ email }),
      setProfilePictureUrl: (url: string) => set({ profilePictureUrl: url }),
      updateMerchantInfo: (info: { name?: string; email?: string; profilePictureUrl?: string }) => 
        set((state) => ({
          name: info.name !== undefined ? info.name : state.name,
          email: info.email !== undefined ? info.email : state.email,
          profilePictureUrl: info.profilePictureUrl !== undefined ? info.profilePictureUrl : state.profilePictureUrl,
        })),
      resetMerchantInfo: () => set(initialState),
    }),
    {
      name: 'merchant-storage', // unique name for localStorage key
      storage: createJSONStorage(() => localStorage),
    }
  )
);
